import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'
import { store } from 'store/index'

import { SHOW_LOADER, HIDE_LOADER } from 'store/loader/actions'
import DeleteModal from 'pages/parts/DeleteModal'
import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [products, setProducts] = useState([])
	const [orderTypes, setOrderTypes] = useState([])
	const [autoAddRuleTypes, setAutoAddRuleTypes] = useState([])
	const [selectedItem, setSelectedItem] = useState({ 'quantity': 1, 'products': [], 'order_types': [] })
	const [showModal, setShowModal] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/auto-add-rules', selectedItem, { loader: true })
		} else {
			response = await POST('/auto-add-rules', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			getData()
			toggleModal(false)
		}
	}

	function toggleModal(bool = false, item = { 'quantity': 1, 'products': [], 'order_types': [] }) {
		setSelectedItem(item)
		setShowModal(bool)
	}

	async function deleteItem() {
		const response = await DELETE('/auto-add-rules', { 'id': deleteModalParams.id }, { loader: true })
		if (httpOk(response)) {
			getData()
			setModalDelete(false)
		}
	}

	async function getData() {
		store.dispatch(SHOW_LOADER());

		var response = await GET('/auto-add-rules', {}, {})
		if (httpOk(response)) setData(response.data)

		store.dispatch(HIDE_LOADER());
	}

	async function getDataAll() {
		store.dispatch(SHOW_LOADER());

		var response
		response = await GET('/auto-add-rules', {}, {})
		if (httpOk(response)) setData(response.data)

		response = await GET('/helper/products', {}, {})
		if (httpOk(response)) setProducts(response.data)

		response = await GET('/helper/order-types', {}, {})
		if (httpOk(response)) setOrderTypes(response.data)

		response = await GET('/helper/auto-add-rule-types', {}, {})
		if (httpOk(response)) setAutoAddRuleTypes(response.data)

		store.dispatch(HIDE_LOADER());
	}

	useEffect(() => {
		getDataAll()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('auto_add_products')} [{data?.data?.length}]
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('auto_add_products')}</th>
									<th style={{ 'minWidth': '100px' }}>{t('quantity')}</th>
									<th style={{ 'width': '20%' }}>{t('auto_add_type')}</th>
									<th style={{ 'width': '20%' }}>{t('order_types')}</th>
									<th style={{ 'width': '40%' }}>{t('products')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.product_name}</td>
										<td>{item.quantity}</td>
										<td>{item.auto_add_rule_type_name}</td>
										<td>{item.order_type_names}</td>
										<td></td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														<div className="table-dropdown-item text-danger"
															onClick={() => {
																setDeleteModalParams({ id: item.id, index: index });
																setModalDelete(true)
															}}>
															<i className="uil-times"></i>
															{t('delete')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('product')}</label>
							<Select
								options={products}
								value={products.find(option => option.id === selectedItem.product_id) || ''}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'product_id': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('quantity')}</label>
							<input type="number" className="form-control" name="quantity"
								value={selectedItem.quantity ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'quantity': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('order_type')}</label>
							<Select
								isMulti
								value={selectedItem.order_types}
								options={orderTypes}
								onChange={(options) => setSelectedItem({ ...selectedItem, 'order_types': options })}
								placeholder=""
								noOptionsMessage={() => ""}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('auto_add_type')}</label>
							<Select
								options={autoAddRuleTypes}
								value={autoAddRuleTypes.find(option => option.id === selectedItem.auto_add_rule_type_id) || ''}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'auto_add_rule_type_id': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Index